import React from 'react';
import { Button } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate,  } from '../../constant';
import { FormSpecimenProvenances } from './FormSpecimenProvenances';
import { Dialog } from 'primereact/dialog';

export const ModalSpecimenProvenances = (props) => {

    const{
        modal, modalTitle, closeDialog, method, loading,
        name, abbreviation, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete
    } = props;

    const footer = (
        <div className='mt-2' style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
            >
                Confirmar
            </Button>

        </div>
    );


    return (
        <Dialog header={modalTitle} visible={modal} onHide={closeDialog}  closable modal blockScroll className='medium-dialog' footer={footer}>
            {
                method === "create"
                ? 
                    <FormSpecimenProvenances
                        button={ModalButtonSave}
                        {...{ loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                :
                    (method === "update")
                        ?
                            <FormSpecimenProvenances
                                button={ModalButtonUpdate}
                                {...{loading, handleInputChange, validaciones, methodAction: saveUpdate, name, abbreviation }}
                            />
                        :
                         null
            }
        </Dialog>
    )
}
